import {type ObservationVariant} from 'web-app/util/graphql/api-types';

export type ObservationEditorModalState =
    | {
          mode: 'new';
          childIds?: string;
          variant: ObservationVariant;
      }
    | {
          mode: 'edit';
          observationId: string;
      };

export enum QueryParams {
    ObservationEditorModalMode = 'ObservationEditorModalMode',
    ObservationEditorModalVariant = 'ObservationEditorModalVariant',
    ObservationEditorModalChildIds = 'ObservationEditorModalChildIds',
    ObservationEditorModalObservationId = 'ObservationEditorModalObservationId',
}

export type QueryParamState =
    | {
          [QueryParams.ObservationEditorModalMode]: 'new';
          [QueryParams.ObservationEditorModalChildIds]?: string;
          [QueryParams.ObservationEditorModalVariant]: ObservationVariant;
      }
    | {
          [QueryParams.ObservationEditorModalMode]: 'edit';
          [QueryParams.ObservationEditorModalObservationId]: string;
      }
    | {[key in QueryParams]: undefined};
